import { ComponentProps, FC } from 'react';

export const WalletIcon: FC<ComponentProps<'svg'>> = (props) => (
	<svg
		width="75"
		height="66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M12 15.3c2 5.6 1.9 12.5 1.5 15.3-2 34.3 20.4 35.9 31.6 34C56.3 62.5 63.8 42 66 39.1c2.2-2.9 5.3-14.1 5.7-22.1.4-8-9-5.2-16.7-3.4C47.3 15.5 36.3 8 28 3.7 19.8-.6 17.3-.3 13.5.3c-3.7.5-4 8-1.5 15Z"
			fill="#EBEDF6"
		/>
		<path
			d="M23.4 14.2c4 1 11.9 2.5 15.3 3.2 18 4 19.5 13.6 25 27.3 5.3 13.8-5.8 19-15.8 18.4-10-.5-30.5-8.2-35.5-15-5-7-12-14.5-11.5-27.2.5-12.8 17.5-8 22.5-6.7Z"
			fill="#F2F2F2"
		/>
		<mask id="a" fill="#fff">
			<rect
				x="33.9"
				y="31.6"
				width="25.5"
				height="16.9"
				rx="1"
				transform="rotate(-43.4 33.9 31.6)"
			/>
		</mask>
		<rect
			x="33.9"
			y="31.6"
			width="25.5"
			height="16.9"
			rx="1"
			transform="rotate(-43.4 33.9 31.6)"
			fill="#6FDB89"
			stroke="#1C308B"
			strokeWidth="4"
			mask="url(#a)"
		/>
		<rect
			x="37.4"
			y="34.8"
			width="20.8"
			height="8.8"
			rx=".5"
			transform="rotate(-43.4 37.4 34.8)"
			fill="#6FDB89"
			stroke="#1C308B"
		/>
		<mask id="b" fill="#fff">
			<rect
				x="44"
				y="35.1"
				width="25.5"
				height="16.9"
				rx="1"
				transform="rotate(-43.4 44 35)"
			/>
		</mask>
		<rect
			x="44"
			y="35.1"
			width="25.5"
			height="16.9"
			rx="1"
			transform="rotate(-43.4 44 35)"
			fill="#C2F0CD"
			stroke="#1C308B"
			strokeWidth="4"
			mask="url(#b)"
		/>
		<rect
			x="46.9"
			y="37.6"
			width="20.8"
			height="8.8"
			rx=".5"
			transform="rotate(-43.4 46.9 37.6)"
			fill="#C2F0CD"
			stroke="#1C308B"
		/>
		<path
			stroke="#1C308B"
			strokeWidth="2"
			strokeLinecap="round"
			d="M13.2 65h57.4"
		/>
		<mask id="c" fill="#fff">
			<path d="M28.2 28.3h29a4 4 0 0 1 4 4v25a4 4 0 0 1-4 4h-29v-33Z" />
		</mask>
		<path
			d="M28.2 28.3h29a4 4 0 0 1 4 4v25a4 4 0 0 1-4 4h-29v-33Z"
			fill="#fff"
		/>
		<path
			d="M28.2 26.3h29a6 6 0 0 1 6 6h-4a2 2 0 0 0-2-2h-29v-4Zm35 31a6 6 0 0 1-6 6h-29v-4h29a2 2 0 0 0 2-2h4Zm-35 4v-33 33Zm29-35a6 6 0 0 1 6 6v25a6 6 0 0 1-6 6v-4a2 2 0 0 0 2-2v-25a2 2 0 0 0-2-2v-4Z"
			fill="#1C308B"
			mask="url(#c)"
		/>
		<mask id="d" fill="#fff">
			<rect x="51.8" y="42.4" width="15.1" height="7.5" rx="1" />
		</mask>
		<rect
			x="51.8"
			y="42.4"
			width="15.1"
			height="7.5"
			rx="1"
			fill="#DCE3F9"
			stroke="#1C308B"
			strokeWidth="4"
			mask="url(#d)"
		/>
		<path
			d="M30 54.2a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
			fill="#FFE66D"
			stroke="#1C308B"
			strokeWidth="2"
		/>
		<path
			d="m23 18.2 3 7M21 23.2l7-3M12.8 28l3 6.8M10.9 32.9l7-3"
			stroke="#A4B1ED"
			strokeWidth="4"
			strokeLinecap="round"
		/>
		<path d="M25 32v13.3M22.1 27.3v17" stroke="#1C308B" strokeLinecap="round" />
	</svg>
);
